export default __webpack_public_path__ + "static/media/title-cn.e6dcb248.webp";